import React, { useRef } from 'react';
import CardProjet from './CardProjet';

const Carousel = ({ projects }) => {
  const scrollRef = useRef(null);

  const scroll = (direction) => {
    const { current } = scrollRef;
    if (current) {
      const scrollAmount = direction === 'left' ? -400 : 400;
      current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  };

  if (!projects || projects.length === 0) {
    return (
      <div className="text-center py-12 text-gray-500">
        Aucun projet à afficher pour le moment.
      </div>
    );
  }

  return (
    <div className="relative">
      {/* Bouton précédent */}
      <button
        onClick={() => scroll('left')}
        className="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white/90 hover:bg-white shadow-lg rounded-full p-2 md:p-3 transition-all hidden md:block"
        aria-label="Projet précédent"
      >
        <svg className="w-6 h-6 text-gray-800" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
        </svg>
      </button>

      {/* Conteneur du carousel */}
      <div
        ref={scrollRef}
        className="flex overflow-x-auto gap-6 pb-4 hide-scrollbar scroll-smooth snap-x snap-mandatory"
      >
        {projects.map((project) => (
          <div
            key={project._id}
            className="flex-shrink-0 w-full sm:w-[calc(50%-12px)] lg:w-[calc(33.333%-16px)] snap-start"
          >
            <CardProjet project={project} />
          </div>
        ))}
      </div>

      {/* Bouton suivant */}
      <button
        onClick={() => scroll('right')}
        className="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white/90 hover:bg-white shadow-lg rounded-full p-2 md:p-3 transition-all hidden md:block"
        aria-label="Projet suivant"
      >
        <svg className="w-6 h-6 text-gray-800" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
        </svg>
      </button>

      {/* Indicateur mobile */}
      <div className="flex justify-center gap-2 mt-4 md:hidden">
        {projects.map((_, index) => (
          <div
            key={index}
            className="w-2 h-2 rounded-full bg-gray-300"
          />
        ))}
      </div>
    </div>
  );
};

export default Carousel;
